<div class="topline__wrap">
  <ng-container *ngFor="let topline of toplines">
    <ng-container *ngTemplateOutlet="toplineItemTemplate; context: { topline: topline }"></ng-container>
  </ng-container>
</div>

<ng-template #toplineItemTemplate
             let-topline="topline">
  <ng-container [ngSwitch]="topline?.toplineItem?.itemType">

    <!--- Connection --->
    <app-topline-connection *ngSwitchCase="'EntityConnectionType'"
                            [targetId]="targetId"
                            [targetType]="targetType"
                            [parentEntityId]="targetId"
                            [topline]="topline"
                            (addClick)="onAddClicked($event)"
                            class="connection--topline">
    </app-topline-connection>


    <!--- Connection --->

    <app-topline-note *ngSwitchCase="'Note'"
                      [campaignId]="appliedToplines.campaignContextId"
                      [targetId]="targetId"
                      [targetType]="targetType"
                      [parentEntityId]="targetId"
                      [topline]="topline"
                      (addClick)="onAddClicked($event)">
    </app-topline-note>


    <!--- Age --->
    <app-topline-age *ngSwitchCase="'Age'"
                     [topline]="topline"
                     [targetId]="targetId"
                     [targetType]="targetType"
                     (addClick)="onAddClicked($event)">
    </app-topline-age>

    <!--- PreferredLanguage --->
    <app-topline-preferred-language *ngSwitchCase="'PreferredLanguage'"
                                    [topline]="topline"
                                    [targetId]="targetId"
                                    [targetType]="targetType"
                                    (addClick)="onAddClicked($event)">
    </app-topline-preferred-language>

    <!-- Email -->
    <app-topline-email *ngSwitchCase="'Email'"
                       [topline]="topline"
                       [targetId]="targetId"
                       [targetType]="targetType"
                       (addClick)="onAddClicked($event)"></app-topline-email>

    <!--Address-->
    <app-topline-address *ngSwitchCase="'Address'"
                         [topline]="topline"
                         [targetId]="targetId"
                         [targetType]="targetType"
                         (addClick)="onAddClicked($event)"></app-topline-address>

    <!--City State-->
    <app-topline-address *ngSwitchCase="'CityState'"
                         [topline]="topline"
                         [targetId]="targetId"
                         [targetType]="targetType"
                         (addClick)="onAddClicked($event)"></app-topline-address>
    <!-- Phone Number-->
    <app-topline-phone *ngSwitchCase="'PhoneNumber'"
                       [topline]="topline"
                       [targetId]="targetId"
                       [targetType]="targetType"
                       (addClick)="onAddClicked($event)"></app-topline-phone>

    <!-- Tag Category-->
    <app-topline-tag-category [topline]="topline"
                              [truncate]="false"
                              [targetId]="targetId"
                              [targetType]="targetType"
                              (addClick)="onAddClicked($event)"
                              *ngSwitchCase="'TagCategory'"></app-topline-tag-category>

    <!-- Social -->
    <app-topline-social *ngSwitchCase="'SocialNetwork'"
                        [topline]="topline"
                        [truncate]="false"
                        [targetId]="targetId"
                        [targetType]="targetType"
                        (addClick)="onAddClicked($event)"></app-topline-social>

    <ng-container *ngSwitchDefault>
      <!--blank-->
    </ng-container>
  </ng-container>
</ng-template>
